import { styled } from "@mui/material";
import MuiDialogActions from "@mui/material/DialogActions";
import type { DialogActionsProps } from "@mui/material/DialogActions";
import { useDialogContext } from "./Dialog";

const DialogActions = styled((props: DialogActionsProps) => {
  const { children, ...rest } = props;
  const dialogContext = useDialogContext();
  return (
    <MuiDialogActions data-size={dialogContext.size} {...rest}>
      {children}
    </MuiDialogActions>
  );
})(({ theme }) => ({
  display: "flex",
  width: "100%",
  backgroundColor: "white",
  padding: theme.spacing(3),

  /**
   * Remove the margin from the first and last child
   * to avoid extra space between the buttons and the dialog specially if the dialog is flex-direction: column
   */
  "& > :not(:first-of-type)": {
    marginLeft: 0,
  },
  "& > :not(:last-of-type)": {
    marginRight: 0,
  },
  "& > :first-of-type": {
    marginLeft: 0,
  },
  "& > :last-of-type": {
    marginRight: 0,
  },

  "&[data-size=lg]": {
    padding: theme.spacing(3, 4),
  },
}));

export default DialogActions;
